@if (isVisible) {
  <div 
    class="dialog-overlay"
    [class.dialog-overlay--enter]="animationClass === 'dialog--enter'"
    [class.dialog-overlay--exit]="animationClass === 'dialog--exit'"
    role="dialog"
    [attr.aria-labelledby]="dialog.title ? 'dialog-title' : null"
    [attr.aria-modal]="true"
  >
    <div 
      class="dialog"
      [class.dialog--enter]="animationClass === 'dialog--enter'"
      [class.dialog--exit]="animationClass === 'dialog--exit'"
    >
      <div class="dialog__content">
        @if (dialog.title) {
          <h2 class="dialog__title" id="dialog-title">{{ dialog.title }}</h2>
        }
        
        @if (dialog.useHtmlMessage) {
          <div class="dialog__message" [innerHTML]="dialog.message"></div>
        } @else {
          <p class="dialog__message">{{ dialog.message }}</p>
        }
      </div>
      
      @if (dialog.options && dialog.options.length > 0) {
        <div class="dialog__footer" [class.dialog__footer--equal-buttons]="dialog.equalButtonWidth" [class.dialog__footer--stacked]="dialog.stackButtons">
          @for (option of dialog.options; track option.value; let index = $index) {
            <button
              type="button"
              class="boton"
              [ngClass]="{
                'boton--primario': option.type === OptionEnum.Positive && !option.class,
                'boton--blanco': option.type === OptionEnum.Negative && !option.class,
                'boton--separadoLeft': index > 0
              }"
              [class]="option.class || ''"
              (click)="onResponse(option)"
            >
              {{ option.title }}
            </button>
          }
        </div>
      }
    </div>
  </div>
}
